import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues, ref } from '@dbk-legacy/muster/utils';
import startOfToday from 'date-fns/start_of_today';
import isValidJsonString from '../../../utils/is-valid-json-string';
import { ymd } from '../../../utils/date';
import calendar from '../../calendar-modal';
import { PAYMENTS_PATH, PAYMENT_TYPE_KEY } from './constant';
import orderBy from 'lodash/orderBy';
import Guid from '../../../utils/guid';
import { encode } from 'base-64';
import { EBANKINGWEBLUX, EBANKINGWEBUK, CHANNEL } from '../../../constants';
import { FETCH_MULTI_SIG_YES, FETCH_MULTI_SIG_NO } from './constant';
import envConfig  from '../../../../db-env-build';

const today = startOfToday();
const testDate = (from, to, tx) => {
  if (!from && !to) return true
  const thisDate = tx.executionDate
  const res = (from ? from<=thisDate : true) && 
    (to ? thisDate<=to : true)
  return res
}
const testAmount = (from, to, tx) => {
  if (!from && !to) return true
  const thisAmount = tx.debitAmount
  const res = (from ? from<=thisAmount : true) && 
    (to ? thisAmount<=to : true)
  return res
}
const testCurrency = (isoCode, tx) => {
  if (!isoCode) return true
  const thisIsoCode = tx.currency.isoCode
  return isoCode.includes(thisIsoCode)
}
// todo test local
const testPortfolio = (pfId, tx) => {
  if (!pfId) return true
  if (!tx.debitAcc || !tx.debitAcc.pfId) return false
  const thisPfId = tx.debitAcc.pfId
  return pfId === thisPfId
}
const testDebitAccount = (accNo, tx) => {
  if (!accNo) return true
  if (!tx.debitAcc || !tx.beneficiaryDetails.accountNo) return false
  const thisAccNo = tx.debitAcc.accNo
  return accNo === thisAccNo
}
const testBeneficiaryName = (pattern, tx) => {
  if (!pattern) return true // default value
  if (!tx.beneficiaryDetails) return false
  const { firstName, lastName } = tx.beneficiaryDetails
  const re = new RegExp(pattern, 'i')
  const res = re.test(firstName) || re.test(lastName)
  return res
}
const testType = (typeDesc, tx) => {
  if (!typeDesc) return true
  if (!tx.paymentType || !tx.paymentType.paymentTypeDesc) return false
  const thisTypeDesc = tx.paymentType.paymentTypeDesc
  const res = thisTypeDesc === typeDesc
  return res
}
// todo test local
const testStatus = (status, tx) => {
  if (!status) return true
  if (!tx.paymentStatus || !tx.paymentStatus.dwoStatus) return false
  const thisStatus =  tx.paymentStatus.dwoStatus.toUpperCase()
  return thisStatus === status
}
export default () =>
  muster()
    .path('payments.fetchSubmittedFilterListLookup', {
      call: async ({ req }, { get, set, call }) => {
        const [messages] = await getValues(get('i18n.messages'));
        const [portfolios] = await getValues(get('app.user.portfoliosData'));
        const portfolioList = portfolios.map((portfolio) => portfolio.title);
        set('payments.portfolioListData', portfolioList);
        let debitAccounts = []
        let paymentTypes = []
        let paymentStatus = []
        let currencies = []
        const [result] = await getValues(get(`${PAYMENTS_PATH}.filterListsLookup`));

        await isValidJsonString(result)
          .then(data => {
            if(envConfig.envConfig === EBANKINGWEBLUX){
              const luxPaymentTypeList= data.submittedPaymentTypeList && data.submittedPaymentTypeList.filter((paymentType) => 
                (paymentType.key !== PAYMENT_TYPE_KEY.DOMESTIC && paymentType.key !==  PAYMENT_TYPE_KEY.SWISS_QR_BILL));
              paymentTypes = paymentTypes.concat(luxPaymentTypeList || []);
            }else if(envConfig.envConfig === EBANKINGWEBUK){
              const ukPaymentTypeList= data.submittedPaymentTypeList && data.submittedPaymentTypeList.filter((paymentType) => 
                (paymentType.key !== PAYMENT_TYPE_KEY.SEPA && paymentType.key !==  PAYMENT_TYPE_KEY.SWISS_QR_BILL));
              paymentTypes = paymentTypes.concat(ukPaymentTypeList || []);
            }else{
              paymentTypes = paymentTypes.concat(data.submittedPaymentTypeList || []);
            }
            debitAccounts = debitAccounts.concat(data.debitAccountList || []);
            paymentStatus = paymentStatus.concat(data.submittedPaymentStatusList || []);
            currencies = currencies.concat(data.currencyList || []);
          })
          .catch(() => {});
        set('payments.debitAccountListData', debitAccounts);
        set('payments.paymentTypeListData', paymentTypes);
        set('payments.statusListData', paymentStatus);
        set('payments.currencyListData', currencies);
      },
    })
    .path('payments.applyFilter', {
      call: async ({ req }, { get, set }) => {
        const opts = req.args[0];
        const fetchMultisig = FETCH_MULTI_SIG_NO;  // for submitted payment filter it is N
        // EBANK-11646 - Make api call to get filter results
        set('payments.transactionListLoading', true);
        const channel = CHANNEL.WEB;
        const deviceCode = '';
        const filterLookupObj = { ...opts };
        await set('payments.paymentFilterLookup', filterLookupObj);
        const filterLookUp = encode(JSON.stringify(filterLookupObj));

        const inputs = `${deviceCode}#@#${channel}#@#${fetchMultisig}#@#${filterLookUp}`;   // will refine this with app development
        const url = `${PAYMENTS_PATH}.listTransactions.["${inputs}"]["${Guid()}"]`;
        const [result] = await getValues(get(url));
        try {
          const filtered = JSON.parse(result).resultList;
          set('payments.filterFlag', true);
          await set('payments.filteredPayments', orderBy(filtered, 'executionDate', 'desc'));
        } catch (e) {
          set('payments.filteredPayments', []);
        }
        set('payments.transactionListLoading', false);
      },
    })
    .path('payments.onFilterCalendarDone', {
      call: async ({ req }, { set }) => {
        const startDate = req.args[0].fromDate
          ? req.args[0].fromDate
          : req.args[0].toDate;
        const endDate = req.args[0].toDate
          ? req.args[0].toDate
          : req.args[0].fromDate;
        if (startDate) {
          await set('payments.filterStartDate', ymd(startDate));
          await set('payments.filterEndDate', ymd(endDate));
        }
      },
    })

    .import('payments.filterCalendar', calendar(), {
      onDone: ref('payments.onFilterCalendarDone'),
    })

    // Payment Multi Signature Filter
    .path('payments.fetchFilterListsLookup', {
      call: async ({ req }, { get, set, call }) => {

        const [messages] = await getValues(get('i18n.messages'));
        const [portfolios] = await getValues(get('app.user.portfoliosData'));
        const portfolioList = portfolios.map((portfolio) => portfolio.title);

        set('payments.multiSignPortfolioListData', portfolioList);

        let debitAccounts = []
        let paymentTypes = []
        let paymentStatus = []
        let currencies = []
        const [result] = await getValues(get(`${PAYMENTS_PATH}.filterListsLookup`));
        
        await isValidJsonString(result)
          .then(data => {
            if (envConfig.envConfig === EBANKINGWEBLUX) {
              const luxPaymentTypeList = data.multisigPaymentTypeList.filter((paymentType) => 
                (paymentType.key !== PAYMENT_TYPE_KEY.DOMESTIC && paymentType.key !== PAYMENT_TYPE_KEY.SWISS_QR_BILL));
              paymentTypes = paymentTypes.concat(luxPaymentTypeList || []);
            } else if (envConfig.envConfig === EBANKINGWEBUK) {
              const ukPaymentTypeList = data.multisigPaymentTypeList.filter((paymentType) => 
                (paymentType.key !== PAYMENT_TYPE_KEY.SEPA && paymentType.key !== PAYMENT_TYPE_KEY.SWISS_QR_BILL));
              paymentTypes = paymentTypes.concat(ukPaymentTypeList || []);
            } else {
              paymentTypes = paymentTypes.concat(data.multisigPaymentTypeList || []);
            }
            debitAccounts = debitAccounts.concat(data.debitAccountList || []);
            paymentStatus = paymentStatus.concat(data.multisigPaymentStatusList || []);
            currencies = currencies.concat(data.currencyList || []);

            set('payments.multiSignDebitAccountListData', debitAccounts);
            set('payments.multiSignPaymentTypeListData', paymentTypes);
            set('payments.multiSignStatusListData', paymentStatus);
            set('payments.multiSignCurrencyListData', currencies);
            set('payments.initiatorListData', data.otherInitiatorsList);
          })
          .catch(() => { });

      },
    })

    .path('payments.applyMultiSignFilter', {
      call: async ({ req }, { get, set, call }) => {
        const opts = req.args[0];
        const fetchMultisig = FETCH_MULTI_SIG_YES;  // for multi sign it is Y
        set('payments.transactionListLoading', true);
        const channel = CHANNEL.WEB;
        const deviceCode = '';

        const filterLookupObj = { ...opts };

        await set('payments.multiSignFilterLookup', filterLookupObj);
        const filterLookUp = encode(JSON.stringify(filterLookupObj));

        const inputs = `${deviceCode}#@#${channel}#@#${fetchMultisig}#@#${filterLookUp}`;   // will refine this with app development
        const url = `${PAYMENTS_PATH}.listTransactions.["${inputs}"]["${Guid()}"]`;

        const [result] = await getValues(get(url));
        try {
          const data = JSON.parse(result)
          const filtered = data.multisigResultList || []; //fallback to empty array
          set('payments.multiSignFilterFlag', true);
          await set('payments.multiSignFilteredPayments', filtered);
          if (data.multiSigNotificationDetails) {
            await set('payments.multiSigNotificationDetails', data.multiSigNotificationDetails || {})
            await call('notifications.pendingCountNotification',{ notificationCategoryCountDtls : data.multiSigNotificationDetails.notificationCategoryCountDtls}) //For updating multi-sig badge count
            await call('payments.updateNotificationBellCount')
          }
        } catch (e) {
          set('payments.multiSignFilteredPayments', []);
        }
        set('payments.transactionListLoading', false);
      },
    })


    .path('payments.filterFlag', variable(false))
    .path('payments.filteredPayments', variable(null))
    .path('payments.portfolioListData', variable(null))
    .path('payments.debitAccountListData', variable(null))
    .path('payments.paymentTypeListData', variable(null))
    .path('payments.statusListData', variable(null))
    .path('payments.currencyListData', variable(null))
    .path('payments.filterStartDate', variable(today))
    .path('payments.filterEndDate', variable(today))
    .path('payments.filterOptions', variable(null))
    .path('payments.paymentFilterLookup', variable(null))

    .path('payments.multiSignFilterFlag', variable(false))
    .path('payments.multiSignFilterOptions', variable(['selectedDate']))
    .path('payments.multiSignPortfolioListData', variable(null))
    .path('payments.multiSignDebitAccountListData', variable(null))
    .path('payments.multiSignPaymentTypeListData', variable(null))
    .path('payments.multiSignStatusListData', variable(null))
    .path('payments.multiSignCurrencyListData', variable(null))
    .path('payments.initiatorListData', variable(null))
    .path('payments.multiSignFilteredPayments', variable([]))
    .path('payments.multiSignFilterLookup', variable(null))
